import Cookies from 'js-cookie';

import { REFRESH_TOKEN_EXPIRATION_TIME, ACCESS_TOKEN_EXPIRATION_TIME } from '~/domains/auth/consts';
import { getCookieDomain } from '~/domains/auth/utils/getCookieDomain';

function setTokens({ accessToken, refreshToken }: { accessToken: string; refreshToken?: string }) {
  const domain = getCookieDomain();

  // Clear the old host-only cookie. Can be removed once all old client cookies have expired
  Cookies.remove('accessToken');
  Cookies.set('accessToken', accessToken, {
    expires: ACCESS_TOKEN_EXPIRATION_TIME,
    domain,
  });

  if (refreshToken) {
    Cookies.remove('refreshToken');
    Cookies.set('refreshToken', refreshToken, {
      expires: REFRESH_TOKEN_EXPIRATION_TIME,
      domain,
    });
  }

  Cookies.set('isLoggedIn', 'true', {
    expires: REFRESH_TOKEN_EXPIRATION_TIME,
    domain: '.splashsports.com',
    secure: true,
    sameSite: 'strict',
  });
}

export { setTokens };
